import { AxiosResponse } from "axios";
import { Result } from "@/main/models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

export abstract class IAddressTypeApi {
	abstract getDomain(): Promise<AxiosResponse<Result<KeyValue[]>>>;
	abstract getDomainPublic(): Promise<AxiosResponse<Result<KeyValue[]>>>;
}
